export default function Guide() {
  const guides = [
    {
      icon: 'ri-calendar-2-line',
      title: 'Cuándo acudir a revisión',
      description: 'Se recomienda una visita anual de rutina, o antes si presentas síntomas como dolor pélvico, sangrado irregular, flujo anormal o molestias durante las relaciones.',
      color: 'from-pink-400 to-pink-500'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Qué preparar para tu consulta',
      description: 'Trae tu historial médico, lista de medicamentos actuales, fecha de tu última menstruación y anota cualquier síntoma o pregunta que desees comentar.',
      color: 'from-blue-400 to-blue-500'
    },
    {
      icon: 'ri-stethoscope-line',
      title: 'Qué esperar durante el examen',
      description: 'La consulta incluye una conversación sobre tu salud, examen físico si es necesario, y explicación clara de cualquier estudio o tratamiento recomendado. Todo en un ambiente de respeto y privacidad.',
      color: 'from-pink-400 to-pink-500'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-pink-50/30 to-blue-50/30">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Guía para tu visita al ginecólogo
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Información útil para que te sientas cómoda y preparada
          </p>
          <div className="w-24 h-1 bg-gradient-to-r from-pink-400 to-blue-400 mx-auto mt-6 rounded-full"></div>
        </div>

        <div className="max-w-5xl mx-auto space-y-6">
          {guides.map((guide, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 border border-gray-100"
            >
              <div className="flex flex-col md:flex-row items-start gap-6">
                <div className={`w-16 h-16 flex items-center justify-center rounded-2xl bg-gradient-to-br ${guide.color} flex-shrink-0`}>
                  <i className={`${guide.icon} text-3xl text-white`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="text-2xl font-semibold text-gray-900 mb-3">
                    {guide.title}
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    {guide.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-4xl mx-auto bg-gradient-to-r from-pink-100 to-blue-100 rounded-2xl p-8 border border-pink-200">
          <div className="flex items-start gap-4">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-information-line text-3xl text-pink-600"></i>
            </div>
            <div>
              <h4 className="text-xl font-semibold text-gray-900 mb-2">Recuerda</h4>
              <p className="text-gray-700 leading-relaxed">
                Tu salud es lo más importante. No dudes en hacer todas las preguntas que tengas durante tu consulta. Estoy aquí para escucharte y brindarte la mejor atención posible en un ambiente de confianza y profesionalismo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
